import { Skeleton } from '@frontend-workspace/react-shared-lib';

export function RegistrationGridSkeleton() {
  return (<>
    <div className='d-flex justify-content-start'>
      <Skeleton animation="wave" width={150} height={50} />
    </div>
    <div className='d-flex justify-content-end'>
      <Skeleton animation="wave" width={150} height={50} />
    </div>
    <Skeleton variant="rectangular" animation="wave" width='100%' height={650} />
  </>);
}

export default RegistrationGridSkeleton;